import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { TokenService, isTokenExpired } from '@auth';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private tokenService: TokenService) {}

  canActivate(): Observable<boolean> {
    const token = this.tokenService.token.getValue();
    if (token && !isTokenExpired(token)) {
      return of(true);
    } else {
      return this.tokenService.refreshToken().pipe(
        map((newToken) => {
          return newToken ? true : false;
        }),
        catchError(() => of(false)),
      );
    }
  }
}
